// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"ed53b05345c32792586c","961":"149949e2ff3b4551ad35","2648":"9d821278e52094ac9408","6540":"fc5f9cffb34b923d70d3"}[chunkId] + ".js";
};